import { NgModule } from '@angular/core';

import { CoreModule } from '../core/core.module';
import { EditFacModalModule } from '../shared/components/edit-fac-modal/edit-fac-modal.module';
import { SharedModule } from '../shared/shared.module';

import { HomeComponent } from './home.component';
import { WidgetComponent } from '../shared/components/widgets/widget.component';
import { FacsTimeComponent } from '../shared/components/widgets/facs-time/facs-time.component';
import { FacsTempComponent } from '../shared/components/widgets/facs-temp/facs-temp.component';
import { FacsFavComponent } from '../shared/components/widgets/facs-fav/facs-fav.component';
import { ScheduledVisitsComponent } from '../shared/components/widgets/scheduled-visits/scheduled-visits.component';
import { ClockComponent } from '../shared/components/widgets/clock/clock.component';
import { FunnelComponent } from '../shared/components/widgets/funnel/funnel.component';
import { ScheduleComponent } from '../shared/components/widgets/schedule/schedule.component';

import { HomeService } from './service/home.service';
import { CtaBannerComponent } from '../cta-banner/cta-banner.component';
import { HomeRealtorComponent } from './home-realtor/home-realtor.component';
import { HomeManagerComponent } from './home-manager/home-manager.component';
import { ManagerFiltersComponent } from './manager-filters/manager-filters.component';
import { SatDatepickerModule, SatNativeDateModule } from 'saturn-datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ChartContactTypeComponent } from './home-manager/components/chart-contact-type/chart-contact-type.component';
import { ChartsModule } from 'ng2-charts';
import { ChartPerformanceTeamComponent } from './home-manager/components/chart-performance-team/chart-performance-team.component';
import {DoneVisitsComponent} from '../shared/components/widgets/done-visits/done-visits.component';
import {FacsReceivedsComponent} from '../shared/components/widgets/facs-receiveds/facs-receiveds.component';
import {ProposalsMadeComponent} from '../shared/components/widgets/proposals-made/proposals-made.component';
import {OutdatedFacsComponent} from '../shared/components/widgets/outdated-facs/outdated-facs.component';
import {HomeManagerService} from './service/home-manager.service';

@NgModule({
  declarations: [
    HomeComponent,
    WidgetComponent,
    FacsTimeComponent,
    FacsTempComponent,
    FacsFavComponent,
    ScheduledVisitsComponent,
    ClockComponent,
    FunnelComponent,
    ScheduleComponent,
    CtaBannerComponent,
    HomeRealtorComponent,
    HomeManagerComponent,
    ManagerFiltersComponent,
    ChartContactTypeComponent,
    ChartPerformanceTeamComponent,
    DoneVisitsComponent,
    FacsReceivedsComponent,
    ProposalsMadeComponent,
    OutdatedFacsComponent
  ],
    imports: [
        CoreModule,
        SharedModule,
        EditFacModalModule,
        SatDatepickerModule,
        SatNativeDateModule,
        MatDatepickerModule,
        ChartsModule
    ],
  exports: [
    HomeComponent
  ],
  providers: [HomeService, HomeManagerService],
})
export class HomeModule {

 }
